import React, { useState, useEffect } from 'react';
import { Button, Form, Upload, Modal, App, Input } from 'antd';
import { EditOutlined, PlusOutlined } from '@ant-design/icons';
import styles from './ProductDetailTemplate8.module.scss';
import type { UploadFile, UploadProps } from 'antd';
import { useAppSelector } from '@/store/hooks';
import RichTextEditor from '@/components/RichTextEditor';

const { TextArea } = Input;

interface ImageUrl {
  url: string;
  name: string;
}

export interface ProductDetailTemplate8Props {
  data: {
    content: string;
  };
  onChange?: (data: any, selfIndex: number) => void;
  editable?: boolean;
  selfIndex?: number;
  thumbnailMode?: boolean;//是否是缩略图模式
  onDelete?: (selfIndex: number) => void;
}

const ProductDetailTemplate8: React.FC<ProductDetailTemplate8Props> = ({
  data,
  onChange,
  editable = true,
  selfIndex = 0,
  thumbnailMode = false,
  onDelete
}) => {
  const { message } = App.useApp();
  const [form] = Form.useForm();
  const [isEditing, setIsEditing] = useState(false);

  // 编辑表单数据
  const [content, setContent] = useState(data?.content || '');
  const [fileList, setFileList] = useState<UploadFile[]>([]);

  // 获取token
  const token = useAppSelector((state) => state.user.token);

  // 初始化数据
  useEffect(() => {
    if (data) {
      setContent(data.content || '');

     
    }
  }, [data]);

  // 图片上传配置
  const uploadProps: UploadProps = {
    name: 'file',
    action: `${process.env.REACT_APP_API_URL}/api/product/save_upload_file`,
    accept: ".mp4,.webm,.ogg,.mov,.avi",
    headers: {
      token: `${token}`
    },
    listType: 'picture-card',
    fileList: fileList,
    beforeUpload: (file) => {
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isLt10M) {
        message.error("Image must be smaller than 10MB!");
      }
      return isLt10M; // 返回 false 阻止上传
    },
    onChange(info) {
      // 复制一份文件列表
      const newFileList = [...info.fileList];

      // 对文件状态进行处理
      newFileList.forEach(file => {
        if (file.response) {
          file.url = file?.response?.data?.url;
        }
      });

      // 更新状态
      setFileList(newFileList);

      if (info.file.status === 'done') {
        message.success(`${info.file.name} uploaded successfully`);
      } else if (info.file.status === 'error') {
        message.error(`${info.file.name} upload failed`);
      }
    },

  };

  // 打开编辑模式
  const handleEdit = () => {
    setIsEditing(true);
    form.setFieldsValue({
      content
    });
  };

  // 保存编辑
  const handleSave = () => {
    form.validateFields().then(values => {
      const updatedData = {
        ...data,
        content: values.content,
      };
      debugger

      onChange && onChange(updatedData, selfIndex);
      setContent(values.content);
      setIsEditing(false);
      message.success('Template updated successfully');
    });
  };

  // 取消编辑
  const handleCancel = () => {
    setIsEditing(false);
   
  };

  // 上传按钮
  const uploadButton = (
    <div>
      <PlusOutlined />
      <div style={{ marginTop: 8 }}>Upload</div>
    </div>
  );

  // 富文本内容变更
  const handleEditorChange = (html: string) => {
    setContent(html);
  };

  return (
    <div className={styles['template-container']}>
      {/* 展示模式 */}


     
      {thumbnailMode ? (
        <div 
          className={styles['template-thumbnail']}
          onClick={handleEdit}
        >
          <div className={styles['thumbnail-number']}>
            {selfIndex + 1}
          </div>
          <div className={styles['thumbnail-content']}>
            <div className={styles['thumbnail-text']} dangerouslySetInnerHTML={{ __html: content }}>
            </div>
          </div>
          <div className={styles['thumbnail-actions']}>
            <Button 
              size="small"
              danger
              className={styles['delete-btn']}
              onClick={(e) => {
                e.stopPropagation();
                // 这里需要调用删除函数，但需要从父组件传入
                onDelete && onDelete(selfIndex);
              }}
            >
              Delete
            </Button>
          </div>
        </div>
      ) : (
        <div className={styles['template-content']} >
          <div className={styles['text-container']}>
            {content && <div className={styles['template-description']} dangerouslySetInnerHTML={{ __html: content }}></div>}
          </div>
          
        </div>
      )}
      

      {/* 编辑模式 */}
      {isEditing && (
        <Modal
          width={1200}
          title="Edit Template"
          open={isEditing}
          onOk={handleSave}
          onCancel={handleCancel}
          okText="Save"
          cancelText="Cancel"
          className={styles['edit-modal']}
        >
          <Form
            form={form}
            layout="vertical"
            initialValues={{
              content
            }}
          >
           

            <Form.Item
              label="Content"
              name="content"
            >
              <RichTextEditor 
                value={content}
                onChange={handleEditorChange}
                height={400}
                placeholder="Please enter detailed product description..."
              />
            </Form.Item>
          </Form>
        </Modal>
      )}
    </div>
  );
};

export default ProductDetailTemplate8; 